import GroupList from '../../features/contacts/components/GroupList'

export default GroupList
